import { SCUIContent } from '../../atomic/organisms';
import React, { FC, useEffect } from 'react';
import { LcwaikikiDashboard } from './components/LcwaikikiDashboard';
import { CircularProgress, FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material';
import { t } from 'i18next';
import { SearchServiceQuery } from '../../services/query';
import './ProductDashboard.scss';
import TimeHelper from '../../utils/time';
import { PD } from './productDashboard.classes';
export const ProductDashboard: FC<any> = () => {
    const [warehouses, setWarehouses] = React.useState([]);
    const [warehousesByGroupId, setWarehousesByGroupId] = React.useState<any>([]);
    const [status, setStatus] = React.useState(1);
    const [warehousesById, setWarehousesById] = React.useState<any>([]);
    let d = new Date();
    const [var1, setVar1] = React.useState('1');
    const [changeDate, setChangeDate] = React.useState<any>(d);
    const handleChange = (event: any) => {
        setVar1(event.target.value);
        if (event.target.value === '1') {
            setChangeDate(d);
        }
        if (event.target.value === '2') {
            setChangeDate(d);
        }
        if (event.target.value === '3') {
            setChangeDate(d);
        }
        if (event.target.value === '4') {
            setChangeDate(d);
        }
        if (event.target.value === '5') {
            setChangeDate(d);
        }
    };

    const getAllWarehousesById = () => {
        SearchServiceQuery.GetWarehouseById(status)
            .then((res: any) => {
                if (res) {
                    setWarehousesById(res.warehouseSummary);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            });
    };

    const getAllWarehousesByGroupId = () => {
        SearchServiceQuery.GetCentralStockInfo()
            .then((res: any) => {
                if (res) {
                    setWarehousesByGroupId(res.data.centralStockInfos);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            });
    };

    const getAllWarehouses = () => {
        SearchServiceQuery.GetAllWarehouses()
            .then((res: any) => {
                if (res) {
                    let parseData = res.warehouseEntities.map((item: any) => {
                        return {
                            id: item.warehouseId || '-',
                            warehouseName: item.warehouseName || ' ',
                            warehouseCode: item.warehouseCode || ' ',
                            warehouseGroupId: item.warehouseGroupId || '',
                        };
                    });
                    setWarehouses(parseData);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            });
    };

    useEffect(() => {
        getAllWarehouses();
        getAllWarehousesByGroupId();
    }, []);

    useEffect(() => {
        getAllWarehousesById();
    }, [status]);

    useEffect(() => {
        getAllWarehousesById();
    }, [status]);

    return (
        <SCUIContent className={PD.page}>
            <Grid className={PD.layout} container spacing={5} justifyContent="space-between">
                <Grid
                    className={PD.headerRow}
                    sx={{ marginBottom: '2rem' }}
                    size={{
                        xl: 4,
                        lg: 10,
                        md: 6,
                        xs: 6,
                    }}
                >
                    <h1 className={[PD.title, 'headtxt'].join(' ')}>{'Product Dashboard'} </h1>
                </Grid>
                <Grid
                    className={PD.dateFilterSection}
                    container
                    justifyContent="flex-end"
                    alignItems="flex-start"
                    sx={{ paddingBottom: '0.5rem' }}
                    size={{
                        xs: 2,
                        md: 12,
                        lg: 3,
                        xl: 3,
                    }}
                >
                    <FormControl className={PD.dateFormControl} fullWidth>
                        <InputLabel id="demo-simple-select-label">Tarih</InputLabel>
                        <Select
                            className={PD.dateSelect}
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={var1}
                            label="Tarih"
                            onChange={handleChange}
                        >
                            <MenuItem className={PD.dateSelectItem} value={'1'}>
                                Bugün
                            </MenuItem>
                            <MenuItem className={PD.dateSelectItem} value={'2'}>
                                Son 3 Gün
                            </MenuItem>
                            <MenuItem className={PD.dateSelectItem} value={'3'}>
                                Son 1 Hafta
                            </MenuItem>
                            <MenuItem className={PD.dateSelectItem} value={'4'}>
                                Son 2 Hafta
                            </MenuItem>
                            <MenuItem className={PD.dateSelectItem} value={'5'}>
                                Son 1 Ay
                            </MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid
                    className={PD.groupSummaryLeft}
                    justifyContent="flex-end"
                    sx={{ paddingBottom: '7rem' }}
                    size={{
                        xs: 6,
                        md: 6,
                        lg: 6,
                        xl: 7,
                    }}
                >
                    <p className={[PD.summaryRowName, 'lineHeightProductDashboard'].join(' ')}>
                        <b>Warehouse Name :</b>
                        {(warehousesByGroupId.length > 0 && warehousesByGroupId[0]['value']) || (
                            <CircularProgress
                                className={PD.summarySpinner}
                                size={'2rem'}
                                sx={{ marginLeft: '1rem', marginTop: '1.3rem' }}
                            />
                        )}{' '}
                    </p>
                    <p className={[PD.summaryRowTotalQty, 'lineHeightProductDashboard'].join(' ')}>
                        <b>Total Quantity :</b>
                        {(warehousesByGroupId.length > 0 && warehousesByGroupId[0]['totalQuantity']) || (
                            <CircularProgress
                                className={PD.summarySpinner}
                                size={'2rem'}
                                sx={{ marginLeft: '1rem', marginTop: '1.3rem' }}
                            />
                        )}{' '}
                    </p>
                    <p className={[PD.summaryRowReservedQty, 'lineHeightProductDashboard'].join(' ')}>
                        <b>Total Reserved Quantity :</b>
                        {(warehousesByGroupId.length > 0 && warehousesByGroupId[0]['totalReservedQuantity']) || (
                            <CircularProgress
                                className={PD.summarySpinner}
                                size={'2rem'}
                                sx={{ marginLeft: '1rem', marginTop: '1.3rem' }}
                            />
                        )}{' '}
                    </p>
                </Grid>

                <Grid
                    className={PD.groupSummaryRight}
                    justifyContent="flex-end"
                    sx={{ paddingBottom: '7rem' }}
                    size={{
                        xs: 6,
                        md: 6,
                        lg: 6,
                        xl: 5,
                    }}
                >
                    <p className={[PD.summaryRowName, 'lineHeightProductDashboard'].join(' ')}>
                        <b>Warehouse Name :</b>
                        {(warehousesByGroupId.length > 0 && warehousesByGroupId[1]['value']) || (
                            <CircularProgress
                                className={PD.summarySpinner}
                                size={'2rem'}
                                sx={{ marginLeft: '1rem', marginTop: '1.3rem' }}
                            />
                        )}{' '}
                    </p>
                    <p className={[PD.summaryRowTotalQty, 'lineHeightProductDashboard'].join(' ')}>
                        <b>Total Quantity :</b>
                        {(warehousesByGroupId.length > 0 && warehousesByGroupId[1]['totalQuantity']) || (
                            <CircularProgress
                                className={PD.summarySpinner}
                                size={'2rem'}
                                sx={{ marginLeft: '1rem', marginTop: '1.3rem' }}
                            />
                        )}{' '}
                    </p>
                    <p className={[PD.summaryRowReservedQty, 'lineHeightProductDashboard'].join(' ')}>
                        <b>Total Reserved Quantity :</b>
                        {(warehousesByGroupId.length > 0 && warehousesByGroupId[1]['totalReservedQuantity']) || (
                            <CircularProgress
                                className={PD.summarySpinner}
                                size={'2rem'}
                                sx={{ marginLeft: '1rem', marginTop: '1.3rem' }}
                            />
                        )}{' '}
                    </p>
                </Grid>
                <Grid
                    className={PD.chartWarehouse}
                    size={{
                        xs: 12,
                        md: 12,
                        lg: 6,
                        xl: 6,
                    }}
                >
                    <LcwaikikiDashboard
                        executionDate={TimeHelper.formatDateDesc(changeDate)}
                        type={'warehouse'}
                        value={1}
                    />
                </Grid>
                <Grid
                    className={PD.chartWarehouseType}
                    size={{
                        xs: 12,
                        md: 12,
                        lg: 6,
                        xl: 6,
                    }}
                >
                    <LcwaikikiDashboard
                        executionDate={TimeHelper.formatDateDesc(changeDate)}
                        type={'warehouseType'}
                        value={5}
                    />
                </Grid>

                <Grid
                    className={PD.warehouseSelectSection}
                    sx={{ marginTop: '3rem', marginLeft: '5rem', paddingRight: '3rem' }}
                    size={{
                        xs: 12,
                        md: 6,
                        lg: 6,
                        xl: 6,
                    }}
                >
                    <FormControl className={PD.warehouseFormControl} fullWidth>
                        <InputLabel id="statusSelectLabel">{t('general.operation') as string}</InputLabel>
                        <Select
                            className={PD.warehouseSelect}
                            labelId="statusSelectLabel"
                            fullWidth
                            id="statusSelect"
                            value={status}
                            defaultValue={0}
                            label="Durum"
                            onChange={(event: any) => {
                                setStatus(event.target.value);
                            }}
                        >
                            {warehouses &&
                                warehouses.map((item: any, index: number) => (
                                    <MenuItem className={PD.warehouseSelectItem} key={index} id={item.id} value={item.id}>
                                        {item.warehouseName}
                                    </MenuItem>
                                ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid
                    className={PD.warehouseSummary}
                    sx={{ marginTop: '3rem' }}
                    size={{
                        xs: 12,
                        md: 6,
                        lg: 6,
                        xl: 4,
                    }}
                >
                    <p className={[PD.summaryRowName, 'lineHeightProductDashboard'].join(' ')}>
                        {' '}
                        <b>Warehouse Name:</b>{' '}
                        {warehousesById['warehouseName'] || (
                            <CircularProgress
                                className={PD.summarySpinner}
                                size={'2rem'}
                                sx={{ marginLeft: '1rem', marginTop: '1.3rem' }}
                            />
                        )}
                    </p>

                    <p className={[PD.summaryRowTotalQty, 'lineHeightProductDashboard'].join(' ')}>
                        {' '}
                        <b>Total Quantity : </b>
                        {warehousesById['totalQuantity'] || (
                            <CircularProgress
                                className={PD.summarySpinner}
                                size={'2rem'}
                                sx={{ marginLeft: '1rem', marginTop: '1.3rem' }}
                            />
                        )}
                    </p>

                    <p className={[PD.summaryRowReservedQty, 'lineHeightProductDashboard'].join(' ')}>
                        {' '}
                        <b>Total Reserved Quantity :</b>{' '}
                        {warehousesById['totalReservedQuantity'] || (
                            <CircularProgress
                                className={PD.summarySpinner}
                                size={'2rem'}
                                sx={{ marginLeft: '1rem', marginTop: '1.3rem' }}
                            />
                        )}
                    </p>
                </Grid>
            </Grid>
        </SCUIContent>
    );
};
